<template>
  <v-container fluid>
    <v-row class="mt-4" align="start">
      <v-col cols="12" md="6">
        <p class="title">
          {{ movementType && movementType === "insert" ? "Inclusão de Grupo Familiar:" : "Implantação:" }}
          Adicionar Titular
        </p>
      </v-col>
      <v-col cols="12" lg="6">
        <v-stepper tile value="1">
          <v-stepper-header>
            <v-stepper-step step="1" color="primary">
              Informações do Beneficiário e do Plano
            </v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step step="2"></v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step step="3"></v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step step="4"></v-stepper-step>
          </v-stepper-header>
        </v-stepper>
      </v-col>
    </v-row>
    <v-row align="center">
      <v-col cols="12">
        <v-form ref="formRegister" v-model="isValidForm" lazy-validation>
          <v-card
            elevation="2"
            class="pa-6"
            rounded="xl">
            <v-form
              ref="formSearch"
              v-model="isValidFormSearch">
              <v-row>
                <v-col cols="12">
                  <p class="title">Informações do Titular</p>
                </v-col>
                <v-col cols="12" md="4"
                  class="pb-0">
                  <label
                    class="label">
                    Grupo Financeiro*
                  </label>
                  <v-autocomplete
                    data-test="beneficiary-plan-information_financialGroup_input"
                    :loading="isLoadingFinancialGroups || loadingForm"
                    :items="financialGroups"
                    :rules="[rule.required]"
                    :disabled="financialGroups.length === 1 || isCriticizedCarrier || isReuseMovement"
                    @input="loadContractByFinancialGroup(beneficiary.financialGroup, 'field')"
                    validate-on-blur
                    v-model="beneficiary.financialGroup"
                    append-icon="fas fa-chevron-down"
                    placeholder="Informe o Grupo Financeiro"
                    item-color="primary"
                    color="primary"
                    item-text="name"
                    item-value="id"
                    outlined
                    @change="onClickSearch"
                  >
                    <template
                      v-slot:item="{item}">
                      <div
                        :data-test="`beneficiary-plan-information_financialGroup_${financialGroups.indexOf(item)}_item`">
                        {{ item.name }}
                      </div>
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col cols="12" md="4"
                  class="pb-0">
                  <label
                    class="label">
                    CPF*
                  </label>
                  <v-text-field
                    data-test="beneficiary-plan-information_cpf_input"
                    placeholder="Informe o CPF"
                    v-model="beneficiary.cpf"
                    v-mask="'###.###.###-##'"
                    :rules="[rule.required, rule.cpf]"
                    :disabled="isReuseMovement"
                    validate-on-blur
                    outlined
                    color="primary"
                    @keyup="onClickSearch"
                  />
                </v-col>
                <v-col cols="12" md="4"
                  class="pb-0">
                  <label
                    class="label">
                    Nome Completo*
                  </label>
                  <v-text-field
                    data-test="beneficiary-plan-information_name_input"
                    ref="beneficiaryName"
                    placeholder="Informe o nome"
                    maxlength="70"
                    v-model.trim="beneficiary.name"
                    outlined
                    color="primary"
                    :rules="[rule.required, rule.validateIsAlphanumeric, rule.name]"
                    validate-on-blur
                    @blur="beneficiary.name = formatter.formatToTitleCase(beneficiary.name)"
                  />
                </v-col>
                <v-col cols="12" md="4"
                  class="pb-0">
                  <label
                    class="label">
                    Nome social
                  </label>
                  <v-text-field
                    placeholder="Informe o nome social"
                    maxlength="70"
                    v-model.trim="beneficiary.socialName"
                    outlined
                    color="primary"
                    validate-on-blur
                    @blur="beneficiary.socialName = formatter.formatToTitleCase(beneficiary.socialName)"
                  />
                </v-col>
                <v-col cols="12" md="4">
                  <label class="label">Departamento</label>
                  <v-text-field
                    data-test="beneficiary-plan-information_department_input"
                    placeholder="Informe o departamento"
                    maxlength="255"
                    v-model="beneficiary.department"
                    outlined
                    color="primary"
                  />
                </v-col>
                <v-col cols="12" md="4"
                  class="pb-0">
                  <label
                    class="label">
                    Centro de Custo
                  </label>
                  <v-row
                    no-gutters>
                    <v-col
                      cols="3">
                      <v-text-field
                        data-test="beneficiary-plan-information_capacityCode_input"
                        validate-on-blur
                        v-model="beneficiary.capacityCode"
                        placeholder="Código"
                        color="primary"
                        outlined
                        class="rounded-r-0"
                        @input="['', null, undefined].some(item => item === beneficiary.capacityCode) ? beneficiary.capacityDescription = '' : false"
                      />
                    </v-col>
                    <v-col
                      cols="9">
                      <v-text-field
                        data-test="beneficiary-plan-information_capacityDescription_input"
                        v-model="beneficiary.capacityDescription"
                        class="rounded-l-0"
                        placeholder="Descrição"
                        color="primary"
                        outlined
                      />
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12" md="4">
                  <label
                    class="label">
                    Data de Admissão*
                  </label>
                  <div class="d-flex flex-column">
                    <v-text-field
                      data-test="beneficiary-plan-information_admissionDate_input"
                      outlined
                      v-model="beneficiary.admissionDate"
                      append-icon="fas fa-calendar-alt"
                      v-mask="'##/##/####'"
                      placeholder="DD/MM/YYYY"
                      color="primary"
                      :rules="[rule.required, rule.requiredDate, rule.isAfterSpecificYear, rule.isDateValid]"
                      validate-on-blur
                    />
                  </div>
                </v-col>
                <v-col
                  cols="12">
                  <v-alert
                    data-test="beneficiary-plan-information_alert_formSearch"
                    :value="alert.show"
                    transition="fade-transition"
                    class="py-4"
                    icon="mdi-alert"
                    color="primary"
                    width="100%"
                    dense
                    outlined>
                    {{ alert.text }}
                  </v-alert>
                </v-col>
              </v-row>
            </v-form>
          </v-card>
          <v-card
            elevation="2"
            class="px-3 py-6 my-6"
            rounded="xl">
            <v-row>
              <v-col
                cols="12"
                class="pb-0">
                <p
                  class="title pb-0 mb-0 pl-2">
                  Benefícios
                </p>
              </v-col>
              <v-col
                cols="12">
                <v-data-table
                  data-test="beneficiary-plan-information_plans_list"
                  :headers="headers"
                  :items="beneficiary.plans"
                  :page="page"
                  class="transparent"
                  hide-default-footer
                  hide-default-header
                  item-key="id">
                  <template
                    v-slot:no-data>
                    <span>
                      Nenhum item foi encontrado.
                    </span>
                  </template>

                  <template
                    v-slot:item="{ item, index }">
                    <div
                      class="px-3">
                      <v-container
                        fluid
                        style="border-bottom: 1px solid var(--v-border-base);">
                        <v-row
                          class="d-flex flex-nowrap pb-4">
                          <div
                            class="d-flex flex-grow-1 flex-shrink-1 pt-8 pb-2 pr-4">
                            <v-row>
                              <v-col
                                v-bind="columnsParam">
                                <label
                                  class="label">
                                  Contrato*
                                </label>
                                <v-autocomplete
                                  data-test="beneficiary-plan-information_contract_input"
                                  :loading="isLoadingContract"
                                  :items="item.contracts"
                                  :rules="item.contract !== null ? [] : [rule.required]"
                                  @input="loadSubcontractByContractId(item, index)"
                                  v-model="item.contract"
                                  validate-on-blur
                                  item-text="text"
                                  item-value="contract"
                                  placeholder="Informe o Contrato"
                                  color="primary"
                                  item-color="primary"
                                  append-icon="fas fa-chevron-down"
                                  outlined
                                >
                                  <template
                                    v-slot:item="data">
                                    <div
                                      :data-test="`beneficiary-plan-information_contract_${item.contracts.indexOf(data.item)}_item`">
                                      {{ data.item.text }}
                                    </div>
                                  </template>
                                </v-autocomplete>
                              </v-col>
                              <v-col
                                v-bind="columnsParam">
                                <label
                                  class="label">
                                  Subcontrato*
                                </label>
                                <v-autocomplete
                                  data-test="beneficiary-plan-information_subcontract_input"
                                  :rules="item.subcontract !== null ? [] : [rule.required]"
                                  :items="item.subcontracts"
                                  :loading="beneficiaryRowSelected === index || isCriticizedCarrier
                                    ? isLoadingSubContract
                                    : false"
                                  @input="loadEligibilityAndUnitByContractIdAndSubcontractId(item, index)"
                                  v-model="item.subcontract"
                                  item-text="text"
                                  item-value="subcontract"
                                  placeholder="Informe o Subcontrato"
                                  color="primary"
                                  item-color="primary"
                                  append-icon="fas fa-chevron-down"
                                  outlined
                                  validate-on-blur
                                >
                                  <template
                                    v-slot:item="data">
                                    <div
                                      :data-test="`beneficiary-plan-information_subcontract_${item.subcontracts.indexOf(data.item)}_item`">
                                      {{ data.item.text }}
                                    </div>
                                  </template>
                                </v-autocomplete>
                              </v-col>
                              <v-col
                                v-bind="columnsParam">
                                <label
                                  class="label">
                                  {{
                                    item.units && item.units.length > 0
                                      ? 'Unidade*'
                                      : 'Unidade'
                                  }}
                                </label>
                                <v-row no-gutters>
                                  <v-col cols="3">
                                    <v-tooltip top color="primary">
                                      <template v-slot:activator="{ on, attrs }">
                                        <div v-bind="attrs" v-on="on">
                                          <v-autocomplete
                                            class="rounded-r-0"
                                            :items="item.units"
                                            v-model="item.unit"
                                            @change="setUnit(item, $event)"
                                            item-text="code"
                                            item-value="id"
                                            color="primary"
                                            outlined
                                            placeholder="Código"
                                            :rules="item.units && item.units.length > 0 ? [rule.required] : []"
                                            append-icon="fas fa-chevron-down"
                                            :disabled="!item.subcontract"
                                            return-object
                                            clearable
                                          />
                                        </div>
                                      </template>
                                      <span>{{ formatUnityTooltip(item.unit, item.unitCode, 'code') }}</span>
                                    </v-tooltip>
                                  </v-col>
                                  <v-col cols="9">
                                    <v-tooltip top color="primary">
                                      <template v-slot:activator="{ on, attrs }">
                                        <div v-bind="attrs" v-on="on">
                                          <v-text-field
                                            class="rounded-l-0"
                                            :value="item.unitDescription || ''"
                                            color="primary"
                                            outlined
                                            placeholder="Descrição"
                                            disabled
                                          />
                                        </div>
                                      </template>
                                      <span>{{ formatUnityTooltip(item.unit, item.unitDescription, 'description') }}</span>
                                    </v-tooltip>
                                  </v-col>
                                </v-row>
                              </v-col>
                              <v-col
                                v-bind="columnsParam">
                                <label
                                  class="label">
                                  Elegibilidade*
                                </label>
                                <v-autocomplete
                                  data-test="beneficiary-plan-information_eligibility_input"
                                  :rules="item.eligibility !== null ? [] : [rule.required]"
                                  :loading="
                                    beneficiaryRowSelected === index || isCriticizedCarrier
                                    ? isLoadingEligibility
                                    : false"
                                  :items="item.eligibilities"
                                  @input="loadPlansByEligibility(item);"
                                  v-model="item.eligibility"
                                  item-text="elegibility_id.name"
                                  item-color="primary"
                                  item-value="id"
                                  placeholder="Elegibilidade"
                                  color="primary"
                                  append-icon="fas fa-chevron-down"
                                  validate-on-blur
                                  outlined
                                >
                                  <template
                                    v-slot:item="data">
                                    <div
                                      :data-test="`beneficiary-plan-information_eligibility_${item.eligibilities.indexOf(data.item)}_item`">
                                      {{ data.item.elegibility_id.name }}
                                    </div>
                                  </template>
                                </v-autocomplete>
                              </v-col>
                              <v-col
                                v-bind="columnsParam">
                                <label
                                  class="label">
                                  Plano*
                                </label>
                                <v-autocomplete
                                  data-test="beneficiary-plan-information_plan_input"
                                  :rules="item.plan !== null ? [] : [rule.required]"
                                  :loading="
                                    beneficiaryRowSelected === index || isCriticizedCarrier
                                    ? isLoadingPlan
                                    : false"
                                  :items="item.plans"
                                  v-model="item.plan"
                                  item-text="name"
                                  item-value="id"
                                  placeholder="Plano"
                                  color="primary"
                                  item-color="primary"
                                  append-icon="fas fa-chevron-down"
                                  validate-on-blur
                                  outlined
                                >
                                  <template
                                    v-slot:item="data">
                                    <div
                                      :data-test="`beneficiary-plan-information_plan_${item.plans.indexOf(data.item)}_item`">
                                      {{ data.item.name }}
                                    </div>
                                  </template>
                                </v-autocomplete>
                              </v-col>
                              <v-col
                                v-bind="columnsParam">
                                <label
                                  class="label">
                                  Início De Vigência*
                                </label>
                                <div
                                  class="d-flex flex-column">
                                  <v-menu
                                    data-test="beneficiary-plan-information_validityDate_menu"
                                    v-model="validityDateMenu[index]"
                                    :close-on-content-click="false"
                                    transition="scale-transition"
                                    offset-y
                                    left
                                    min-width="auto">
                                    <template
                                      v-slot:activator="{ on, attrs }">
                                      <v-text-field
                                        data-test="beneficiary-plan-information_validityDate_input"
                                        :ref="`ValidityDateTextField-${index}`"
                                        :disabled="!item.contract"
                                        :rules="validityDateRules(item)"
                                        @click="getAllowedDates(item, index)"
                                        @click:clear="clearScheduledReleaseDate(item)"
                                        v-model="item.validityDate"
                                        :loading="
                                          beneficiaryRowSelected === index || isCriticizedCarrier
                                          ? isLoadingValidityDate
                                          : false"
                                        append-icon="fas fa-calendar-alt"
                                        placeholder="DD/MM/YYYY"
                                        v-mask="'##/##/####'"
                                        color="primary"
                                        v-bind="attrs"
                                        v-on="on"
                                        readonly
                                        clearable
                                        outlined
                                        validate-on-blur
                                        :hide-details="!validityDateInputIsUsingRules(item, `ValidityDateTextField-${index}`)"
                                      />
                                    </template>
                                    <AllowedDatePicker
                                      data-test="beneficiary-plan-information_AllowedDatePicker_component"
                                      @date="updateValidityDate($event, item, index)"
                                      :allowedDates="item.allowedDates"
                                    />
                                  </v-menu>
                                  <span  
                                    v-if="item && item.cutOffDate && item.cutOffDate.length > 0"  
                                    class="text-caption pl-3">  
                                    Dia de corte: <b>{{ item.cutOffDate }}</b>  
                                  </span>
                                </div>
                              </v-col>
                              <v-col
                                v-if="shouldRenderMovementDeadlineField(
                                  item.scheduledReleaseDate,
                                  item.showScheduledReleaseDate,
                                  item.loadingScheduledReleaseDate
                                )"
                                :key="getMovementDeadlineFieldRenderKey(
                                  item.movementDeadlineConfig,
                                  item.scheduledReleaseDate,
                                  item.loadingScheduledReleaseDate,
                                  item.contract || item.plan || 'beneficiary-plan-col'
                                )"
                                v-bind="columnsParam">
                                <label class="label">Data Agendada de Liberação</label>
                                <v-tooltip
                                  :key="getMovementDeadlineFieldRenderKey(
                                    item.movementDeadlineConfig,
                                    item.scheduledReleaseDate,
                                    item.loadingScheduledReleaseDate,
                                    item.contract || item.plan || 'beneficiary-plan-tooltip'
                                  )"
                                  top>
                                  <template v-slot:activator="{ on, attrs }">
                                    <div v-bind="attrs" v-on="on">
                                      <v-text-field
                                          :key="getMovementDeadlineFieldRenderKey(
                                            item.movementDeadlineConfig,
                                            item.scheduledReleaseDate,
                                            item.loadingScheduledReleaseDate,
                                            item.contract || item.plan || 'beneficiary-plan'
                                          )"
                                          outlined
                                          :value="item.scheduledReleaseDate"
                                          color="primary"
                                          readonly
                                          append-icon="fas fa-calendar-alt"
                                          :loading="item.loadingScheduledReleaseDate"
                                        />
                                    </div>
                                </template>
                                <span>{{ getMovementDeadlineTooltip(item.validityDate, item.movementDeadlineConfig) }}</span>
                              </v-tooltip>
                            </v-col>
                            </v-row>
                          </div>
                          <div
                            class="d-flex align-center justify-center flex-grow-0 flex-shrink-0 px-4"
                            style="background-color: var(--v-muted-base);">
                            <v-btn
                              data-test="beneficiary-plan-information_plan-remove_button"
                              :disabled="beneficiary && beneficiary.plans && beneficiary.plans.length === 1"
                              color="error"
                              small
                              fab
                              elevation="2"
                              @click="onClickDel(item)">
                              <v-icon
                                size="16"
                                color="muted">
                                fas fa-trash
                                </v-icon>
                            </v-btn>
                          </div>
                        </v-row>
                      </v-container>
                    </div>
                  </template>
                </v-data-table>
                <v-container
                  fluid
                  class="px-6">
                  <v-row>
                    <v-col
                      cols="12"
                      class="px-0 pt-0">
                      <v-sheet
                        min-height="100"
                        width="100%"
                        color="muted"
                        class="d-flex justify-center align-center">
                        <v-btn
                          data-test="beneficiary-plan-information_plan-add_button"
                          v-if="!isCriticizedCarrier"
                          class="muted-accent"
                          height="50"
                          width="50"
                          icon
                          @click="onClickAdd()">
                          <v-icon
                            size="20"
                            color="muted">
                            fas fa-plus
                          </v-icon>
                        </v-btn>
                      </v-sheet>
                    </v-col>
                  </v-row>
                </v-container>
              </v-col>
            </v-row>
          </v-card>
          <div
            v-if="violations && violations.length >0">
            <ViolationRulesAlert  :violations="violations"/>
          </div>
        </v-form>
      </v-col>
    </v-row>
    <v-footer>
      <v-row class="d-flex pt-6 justify-end">
        <v-btn
          data-test="beneficiary-plan-information_cancel-form_button"
          class="mr-6"
          x-large
          outlined
          color="primary"
          width="250px"
          @click="onClickCancel()"
        >
          <v-icon
            left>
            fas fa-chevron-left
          </v-icon>
          Voltar
        </v-btn>
        <v-btn
          data-test="beneficiary-plan-information_continue-form_button"
          class="white--text mr-10"
          x-large
          color="primary"
          width="250px"
          :loading="isLoadingValidation"
          @click="validateGracePeriod()"
        >
          {{ continueWithCriticism ? 'Prosseguir com crítica' : 'Próximo' }}
          <v-icon
            right color="foreground-accent">
            fas fa-chevron-right
          </v-icon>
        </v-btn>
      </v-row>
    </v-footer>
    <BeneficiaryDialog
      :show="dialog.show"
      :beneficiaries="beneficiaries"
      @confirm="confirmBeneficiaryDialog"
      @close="closeBeneficiaryDialog"
    />

    <SnackbarCustomize ref="SnackbarCustomize" />

    <div v-if="isCriticizedCarrier">
      <ViewCriticizedViolationDialog />
    </div>

     <v-dialog v-model="validateGraceModal" persistent max-width="800" data-test="beneficiary-plan-information_validateGraceModal_modal">
          <v-card width="800" class="rounded-lg">
            <v-card-title class="primary foreground-accent--text text-h5 font-weight-bold px-8 py-4">
              <v-row
                class="d-flex justify-space-between align-center ma-0">
                <span>Incidência de Carência</span>
                <v-icon color="foreground-accent" @click="adjustOutOfDeadlineDate()" data-test="beneficiary-plan-information_closeValidateGrace_button">
                  fas fa-times
                </v-icon>
              </v-row>
            </v-card-title>

            <v-card-text class="mt-5 px-8">
              <v-form ref="formFilterExportMovement">
                <v-row justify="start">
                  <v-col>
                    <p>A movimentação solicitada excede o prazo máximo em relação à Data do Evento. Haverá incidência de carência.</p>
                    <p>Deseja <strong>ajustar a data da movimentação</strong> ou <strong>prosseguir com a configuração?</strong></p>
                    <div v-for="grace in gracePeriods" :key="`grace-${grace.benefitId}-${grace.policy}`">
                      <p v-if="grace.hasGracePeriod" class="font-weight-bold">
                        {{ getGracePeriodMessage(grace) }}
                      </p>
                    </div>
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>

            <v-card-actions
              class="px-8 py-5">
              <v-spacer />
              <v-btn color="primary" width="220px" outlined @click="adjustOutOfDeadlineDate()">
                Ajustar data
              </v-btn>
              <v-btn color="primary" width="220px" @click="confirmGracePeriod()">
                Continuar configuração
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
  </v-container>
</template>
<script>
import Formatters from '@/shared/formatters/formatters';
import FinancialGroupService from '@/services-http/contract/FinancialGroupService';
import ContractService from '@/services-http/contract/ContractService';
import ContractUnitService from '@/services-http/contract/ContractUnitService';
import PhysicalPersonService from '@/services-http/contract/PhysicalPersonService';
import Rules from '@/shared/validators/formRules';
import BeneficiaryDialog from '@/components/BeneficiaryDialog/BeneficiaryDialog.vue';
import ContractEligibilityService from '@/services-http/contract/ContractEligibilityService';
import ContractProductService from '@/services-http/contract/ContractProductService';
import lodash from 'lodash';
import ViewCriticizedViolationDialog from '@/components/DynamicDialogInformation/ViewCriticizedViolationDialog.vue';
import VerifyRoutesMixin from '@/shared/mixins/routeManagement/verifyRoutesMixin';
import MovementRecordFormFieldsToValidate from '@/shared/validators/movementRecordFormFieldsToValidate';
import MovementRecordService from '@/services-http/sdi/MovementRecordService';
import ViolationRulesAlert from '@/components/CustomAlerts/ViolationRulesAlert.vue';
import PayrollService from '@/services-http/sdi/PayrollService';
import SnackbarCustomize from '@/components/CustomAlerts/SnackbarCustomize.vue';
import GenericFunctionsMixin from '@/shared/mixins/genericFunctions/genericFunctionsMixin';
import AllowedDatePicker from '@/components/AllowedDatePicker/AllowedDatePicker.vue';
import CarrierService from '@/services-http/contract/CarrierService';
import moment from 'moment';
import AuthorityManagementMixin from '@/shared/mixins/authorityManagement/authorityManagementMixin';
import DocumentService from '@/services-http/sdi/DocumentService';
import InsuredService from '@/services-http/contract/InsuredService';
import ReuseMovementMixin from '@/shared/mixins/movementRecords/reuse/ReuseMovementMixin';
import MovementRecordsMixin from '@/shared/mixins/movementRecords/movementRecordsMixin';
import UnityMixin from '@/shared/mixins/unityMixin/unitymixin';

export default {
  name: 'BeneficiaryAdditionalInformation',

  components: {
    BeneficiaryDialog,
    ViewCriticizedViolationDialog,
    ViolationRulesAlert,
    SnackbarCustomize,
    AllowedDatePicker,
  },

  data: () => ({
    documentService: null,
    insuredService: null,
    loadingForm: false,
    validityDatePicker: null,
    validityDateMenu: [],
    carrierService: null,
    moment,
    alert: {
      show: false,
      text: '',
      error: {
        notFound: 'Não foram encontrados resultados para a pesquisa.',
        emptySearch: 'Por favor, preencha um CPF válido ou o nome para pesquisar.',
        isContractSelected: 'Este contrato já foi selecionado. Por favor, selecione um contrato diferente.',
        hasDuplicated: 'Existem contratos duplicados. Por favor, verifique o preenchimento.',
        genericError: 'Ocorreu um erro ao buscar o beneficiário.',
      },
    },
    fab: null,
    beneficiary: {
      cpf: null,
      name: null,
      socialName: null,
      admissionDate: null,
      department: null,
      capacityDescription: null,
      capacityCode: null,
      plans: [
        {
          contract: null,
          contracts: null,
          subcontract: null,
          subcontracts: null,
          eligibility: null,
          eligibilities: null,
          unit: null,
          units: [],
          unitId: null,
          unitCode: null,
          unitDescription: null,
          plan: null,
          plans: null,
          validityDate: '',
          allowedDates: [null],
        },
      ],
    },
    dialog: { show: false },
    financialGroups: [],
    fieldsToRulesValidation: [],
    beneficiaryRowSelected: null,
    headers: [
      {
        text: 'Grupo Financeiro',
        value: 'financialGroup',
        align: 'center',
        sortable: false,
      },
      {
        text: 'Contrato',
        value: 'contract',
        align: 'center',
        sortable: false,
      },
      {
        text: 'Subcontrato',
        value: 'subcontract',
        align: 'center',
        sortable: false,
      },
      {
        text: 'Elegibilidade',
        value: 'eligibility',
        align: 'center',
        sortable: false,
      },
      {
        text: 'Plano',
        value: 'plan',
        align: 'center',
        sortable: false,
      },
      {
        text: 'Início de Vigência',
        value: 'validityDate',
        align: 'center',
        sortable: false,
      },
      {
        text: 'Ações',
        value: 'actions',
        align: 'center',
        sortable: false,
      },
    ],
    isValidForm: true,
    isValidFormSearch: true,
    loading: false,
    loadingSearchButton: false,
    movementType: null,
    scheduledReleaseMovementType: 'inclusion',
    page: 1,
    beneficiaries: [],
    isRHProtegido: false,
    insuranceCarrierId: null,
    isLoadingFinancialGroups: false,
    isLoadingContract: false,
    isLoadingSubContract: false,
    isLoadingEligibility: false,
    isLoadingPlan: false,
    isCriticizedCarrier: false,
    isLoadingValidation: false,
    isLoadingValidityDate: false,
    hasViolation: false,
    violations: [],
    continueWithCriticism: false,
    componentLoaded: false,
    validateGraceModal: false,
    gracePeriods: [],
    hasAcceptedGracePeriod: null,
    columnsParam: {
      cols: '12',
      xl: '4',
      lg: '4',
      md: '6',
      sm: '12',
      class: 'py-1',
    },
    searchTimeout: null,
  }),

  watch: {
    beneficiary: {
      handler(val) {
        if (this.continueWithCriticism) {
          this.continueWithCriticism = false;
        }
      },
      deep: true,
      immediate: true,
    },
    'beneficiary.admissionDate': function (newVal, oldVal) {
      if (newVal !== oldVal) {
        if (this.beneficiary && this.beneficiary.plans && this.beneficiary.plans.length > 0 && !this.isCriticizedCarrier) {
          this.beneficiary.plans.forEach((plan) => { this.formatter.isEmptyValue(plan.validityDate) ? plan.validityDate = '' : false; });
        }
      }
    },
  },

  async mounted() {
    await this.loadFinancialGroups();
    await this.loadDataSessionStorage();
  },

  destroyed() {
    this.componentLoaded = false;
  },

  mixins: [
    VerifyRoutesMixin,
    ReuseMovementMixin,
    GenericFunctionsMixin,
    AuthorityManagementMixin,
    MovementRecordsMixin,
    UnityMixin,
  ],

  methods: {
    setUnit(item, event) {
      item.unit = event || null;
      item.unitId = event ? event.id : null;
      item.unitCode = event ? event.code : null;
      item.unitDescription = event ? event.description : null;
    },
    validityDateRules(item) {
      if (!item || (item && item.validityDate && item.validityDate !== null)) return [];

      return [
        this.rule.required,
        this.rule.requiredDate,
        this.rule.isAfterSpecificYear,
        this.rule.isDateValid,
        this.rule.endDateIsGreaterThanOrEqualToStartDate(
          this.beneficiary.admissionDate,
          item.validityDate,
          'Data início de vigência deve ser maior ou igual a data de admissão',
        ),
      ];
    },
    validityDateInputIsUsingRules(item, reference) {
      const validityDateRules = this.validityDateRules(item);

      const validityDateReference = reference && this.$refs && this.$refs[reference] ? this.$refs[reference] : false;

      if (validityDateReference) {
        const validityDateElement = this.$refs[reference];
        const hasMessages = validityDateElement && validityDateElement.hasMessages ? validityDateElement.hasMessages : false;

        if (!hasMessages) return false;
      }

      return validityDateRules.length > 0;
    },
    async getAllowedDates(item, beneficiaryItem) {
      if (this.loadingForm) return;

      this.validityDateInputIsUsingRules();
      const menuIndex = Number.isInteger(beneficiaryItem) ? beneficiaryItem : null;

      if (menuIndex !== null) {
        this.$set(this.validityDateMenu, menuIndex, false);
      }

      if (!this.isCriticizedCarrier && (!item || !item.contracts || item.contracts.length === 0)) {
        this.$refs.SnackbarCustomize.open('error', 'Defina um Grupo Financeiro');
        return;
      }

      const contractIds = item.contract
        ? [item.contract]
        : item.contracts.map((contract) => contract.contract);

      const movementAdmissionDate = this.beneficiary.admissionDate
        ? this.beneficiary.admissionDate
        : beneficiaryItem && beneficiaryItem.admissionDate
          ? beneficiaryItem.admissionDate
          : null;

      const formatedEventDate = movementAdmissionDate ? moment(movementAdmissionDate, 'DD/MM/YYYY').format('YYYY-MM-DD') : null;

      if (!formatedEventDate) {
        this.$refs.SnackbarCustomize.open('error', 'É necessário informar a Data de Admissão.');
        this.$set(item, 'allowedDates', [null]);
        return;
      }

      try {
        const response = await this.carrierService.GetAllowedDates(contractIds, this.movementType, formatedEventDate);

        if (response && response.status === 200) {
          const allowedDates = Array.isArray(response.data) ? response.data : [null];
          this.$set(item, 'allowedDates', allowedDates);

          await this.$nextTick();

          if (menuIndex !== null) {
            this.$set(this.validityDateMenu, menuIndex, true);
          }
        }
      } catch (error) {
        this.$set(item, 'allowedDates', [null]);
      }
    },
    async updateValidityDate(value, item, index) {
      if (this.loadingForm) return;
      if (value) {
        item.validityDate = moment(value, 'YYYY-MM-DD').format('DD/MM/YYYY');
        this.validityDateMenu.splice(index);
        await this.$nextTick();
      }

      await this.validateShowScheduledReleaseDate(item);
    },
    confirmBeneficiaryDialog(item) {
      this.clearSessionStorage();
      this.dialog.show = false;
      this.beneficiary.name = this.formatter.formatToTitleCase(item.name);
      this.beneficiary.socialName = item.socialHolderName ? this.formatter.formatToTitleCase(item.socialHolderName) : null;
      this.beneficiary.admissionDate = item.admissionDate ? this.formatter.formatDate(item.admissionDate) : item.admission_date ? this.formatter.formatDate(item.admission_date) : null;
      this.beneficiary.cpf = item.cpf ? this.formatter.formatCpf(item.cpf) : item.documentNumber ? this.formatter.formatCpf(item.documentNumber) : null;
      this.$nextTick(() => {
        this.$refs.beneficiaryName.focus();
      });
      sessionStorage.setItem('hasHolder', JSON.stringify(item));
    },
    closeBeneficiaryDialog() {
      this.dialog.show = false;
    },
    closeAlert() {
      setTimeout(() => {
        this.alert.show = false;
        this.alert.text = '';
      }, 5000);
    },
    async loadDataSessionStorage() {
      sessionStorage.removeItem('selectedDate');
      if (sessionStorage.getItem('beneficiaryContractedPlan') && !this.isReuseMovement) {
        const beneficiaryStore = JSON.parse(sessionStorage.getItem('beneficiaryContractedPlan'));
        this.violations = sessionStorage.getItem('beneficiaryContractedPlanViolations') ? JSON.parse(sessionStorage.getItem('beneficiaryContractedPlanViolations')) : [];

        if (beneficiaryStore && beneficiaryStore.plans && beneficiaryStore.plans.length > 0) {
          beneficiaryStore.admissionDate = this.formatter.formatDate(beneficiaryStore.admissionDate);

          if (sessionStorage.getItem('isCriticizedCarrier')) {
            this.isCriticizedCarrier = true;
          }

          const plans = [];

          for (const plan of beneficiaryStore.plans) {
            const selectedUnitId = plan.unitId || (plan.unit && plan.unit.id) || null;
            const selectedUnitCode = plan.unitCode || (plan.unit && plan.unit.code) || null;
            const selectedUnitDescription = plan.unitDescription || (plan.unit && plan.unit.description) || null;
            const normalizedPlan = {
              ...plan,
              units: Array.isArray(plan.units) ? plan.units : [],
              unit: selectedUnitId
                ? {
                  id: selectedUnitId,
                  code: selectedUnitCode,
                  description: selectedUnitDescription,
                }
                : null,
              unitId: selectedUnitId,
              unitCode: selectedUnitCode,
              unitDescription: selectedUnitDescription,
            };

            await this.loadUnitByContractIdAndSubcontractId(normalizedPlan);
            if (normalizedPlan.unitId) {
              await this.getUnitById(normalizedPlan.unitId, normalizedPlan);
            }

            if (plan.validityDate) {
              await this.getAllowedDates(normalizedPlan, beneficiaryStore);
            }

            plans.push({
              ...normalizedPlan,
              eligibility: normalizedPlan.eligibilityInternalId ? normalizedPlan.eligibilityInternalId : normalizedPlan.eligibility,
              validityDate: this.formatter.formatDate(normalizedPlan.validityDate),
              movementDeadlineConfig: null,
              scheduledReleaseDate: null,
              showScheduledReleaseDate: false,
              loadingScheduledReleaseDate: false,
            });

            this.isLoadingValidityDate = false;
          };

          beneficiaryStore.plans = plans;

          this.beneficiary = {};
          this.beneficiary = await lodash.cloneDeep(beneficiaryStore);

          this.beneficiary.financialGroup = beneficiaryStore.financialGroup;
          this.beneficiary.department = beneficiaryStore.department;
          this.beneficiary.capacityCode = beneficiaryStore.capacityCode;
          this.beneficiary.capacityDescription = beneficiaryStore.capacityDescription;
          this.beneficiary.socialName = beneficiaryStore.socialHolderName ? this.formatter.formatToTitleCase(beneficiaryStore.socialHolderName) : null;
          this.beneficiary.cpf = this.formatter.formatCpf(beneficiaryStore.cpf);

          if (sessionStorage.getItem('isCriticizedCarrier')) {
            await this.loadContractByFinancialGroup(this.beneficiary.plans[0]);
          }
        }
      }

      if (this.isReuseMovement) {
        this.loadingForm = true;

        await this.mountFormToReuse();

        this.loadingForm = false;
      }
    },
    async mountFormToReuse() {
      const movementRecordSession = this.getReuseMovementRecord();
      movementRecordSession.movementRecordIdToReuse = movementRecordSession.id;
      delete movementRecordSession.id;

      const benefitData = await this.mountBenefitData(movementRecordSession);
      const beneficiaryData = await this.mountBeneficiaryData(movementRecordSession, benefitData);
      const complementaryData = this.mountComplementaryData(movementRecordSession);
      const addressData = this.mountAddressData(movementRecordSession);
      const bankData = this.mountBankData(movementRecordSession);
      const holderAttachments = await this.getHolderAttachmentsToReuse(movementRecordSession);
      const dependentsAttachments = await this.getDependentsAttachmentsToReuse(movementRecordSession);

      sessionStorage.setItem('beneficiaryContractedPlan', JSON.stringify(beneficiaryData));
      sessionStorage.setItem('beneficiaryAdditionalInfo', JSON.stringify(complementaryData));
      sessionStorage.setItem('beneficiaryAddress', JSON.stringify(addressData));
      sessionStorage.setItem('beneficiaryBank', JSON.stringify(bankData));
      sessionStorage.setItem('holderDocuments', JSON.stringify(holderAttachments));
      sessionStorage.setItem('dependentsList', JSON.stringify(dependentsAttachments));

      this.beneficiary = beneficiaryData;
    },
    async getAvailableContracts(insuredDocumentNumber, contracts, contractIdKey) {
      const { data: { content: beneficiaryBenefits } } = await this.insuredService.FindAllByFilters(`cpf=${insuredDocumentNumber}`);
      const activeBenefits = Array.isArray(beneficiaryBenefits) && beneficiaryBenefits.length > 0
        ? beneficiaryBenefits.filter((benefit) => benefit.situation === 'ACTIVE')
        : [];
      const benefitContractIds = activeBenefits.map((benefit) => benefit.contractId);
      const availableContracts = benefitContractIds.length > 0
        ? contracts.filter((contractObj) => !benefitContractIds.includes(contractObj[contractIdKey]))
        : contracts;

      return availableContracts;
    },
    onClickAdd() {
      const plan = {
        financialGroup: this.beneficiary.financialGroup,
        contract: null,
        contracts: null,
        subcontract: null,
        subcontracts: null,
        eligibility: null,
        eligibilities: null,
        unit: null,
        units: [],
        unitId: null,
        unitCode: null,
        unitDescription: null,
        plan: null,
        plans: null,
        validityDate: null,
        movementDeadlineConfig: null,
        scheduledReleaseDate: null,
        showScheduledReleaseDate: false,
        loadingScheduledReleaseDate: false,
      };

      this.beneficiary.plans.push(plan);

      if (this.beneficiary.plans.length > 1) {
        const { contracts } = this.beneficiary.plans[0];
        this.beneficiary.plans[this.beneficiary.plans.length - 1].contracts = contracts;
      }
    },
    onClickDel(item) {
      if (this.beneficiary && this.beneficiary.plans && this.beneficiary.plans.length > 0) {
        const elementPosition = this.beneficiary.plans.indexOf(item);
        this.beneficiary.plans.splice(elementPosition, 1);
      }

      if (this.beneficiary && this.beneficiary.plans && !this.beneficiary.plans.length > 0) {
        this.financialGroup = null;
      }

      this.deleteSessionStorages();
    },
    deleteSessionStorages() {
      if (this.isReuseMovement) return;

      const sessionStorageNames = ['dependents', 'holderDocuments'];

      sessionStorageNames.forEach((sessionName) => {
        if (sessionStorage.getItem(sessionName)) {
          sessionStorage.removeItem(sessionName);
        }
      });
    },
    onClickCancel() {
      this.clearSessionStorage();
      const name = this.isRHProtegido ? 'HomeRHProtegido' : 'HomeAllMenus';
      if (!this.isReuseMovement) {
        this.redirectRouter(name, { isRHProtegido: this.isRHProtegido });
        return;
      }
      sessionStorage.removeItem('isReuse');
      this.redirectRouter('Movement', { isRHProtegido: this.isRHProtegido }, { movement: 'movement' });
    },
    async validateGracePeriod() {
      if (!this.$refs.formSearch.validate()) {
        !this.$refs.formRegister.validate();
        return;
      }

      if (!this.$refs.formRegister.validate()) return;

      this.gracePeriods = [];
      this.clearOutOfDeadlineSession();
      if (this.beneficiary.cpf && this.beneficiary.name && this.beneficiary.admissionDate) {
        if (this.hasDuplicatedContracts()) {
          this.alert.show = true;
          this.alert.text = this.alert.error.hasDuplicated;
          this.closeAlert();
          return;
        }

        let params = [];
        if (this.beneficiary && this.beneficiary.plans && this.beneficiary.plans.length) {
          params = this.beneficiary.plans.map((p) => ({
            parentContractId: p.contract,
            eventDate: this.formatter.formatDateBRtoString(this.beneficiary.admissionDate),
            startDate: this.formatter.formatDateBRtoString(p.validityDate),
          }));

          this.getValidateGracePeriod(params);
        }
      } else {
        this.$refs.SnackbarCustomize.open('error', 'Preencha todas as informações do titular');
      }
    },
    async onClickFinish() {
      if (!this.continueWithCriticism) {
        this.violations = [];
      }

      if (this.beneficiary.cpf && this.beneficiary.name && this.beneficiary.admissionDate) {
        if (this.hasDuplicatedContracts()) {
          this.alert.show = true;
          this.alert.text = this.alert.error.hasDuplicated;
          this.closeAlert();
          return;
        }

        let plans = [];
        if (this.beneficiary && this.beneficiary.plans && this.beneficiary.plans.length) {
          plans = this.beneficiary.plans.map((p) => {
            const plano = p.plans.find(item => item.id === p.plan);
            const contract = p.contracts
              .find((contract) => contract.contract === p.contract);

            return {
              index: p.index,
              financialGroup: p.financialGroup,
              contract: p.contract,
              contracts: p.contracts,
              subcontract: p.subcontract,
              subcontracts: p.subcontracts,
              eligibility: p.eligibility,
              eligibilityInternalId: p.eligibility,
              eligibilities: p.eligibilities,
              unit: p.unit,
              unitId: p.unitId || (p.unit && p.unit.id) || null,
              unitCode: p.unitCode || (p.unit && p.unit.code) || null,
              unitDescription: p.unitDescription || (p.unit && p.unit.description) || null,
              carrierId: contract.accountID,
              plan: p.plan,
              plans: p.plans,
              planCode: plano.code,
              validityDate: this.formatter.formatDateBRtoString(p.validityDate),
              hasAcceptedGracePeriod: this.isAcceptedGracePeriod(p.contract),
            };
          });
        }

        const beneficiaryContractedPlan = {
          cpf: this.formatter.removeNonDigit(this.beneficiary.cpf),
          name: this.beneficiary.name,
          socialHolderName: this.beneficiary.socialName ? this.beneficiary.socialName : null,
          admissionDate: this.formatter.formatDateBRtoString(this.beneficiary.admissionDate),
          financialGroup: this.beneficiary.financialGroup,
          department: this.beneficiary.department,
          costCenterDepartment: this.beneficiary.department,
          capacityCode: this.beneficiary.capacityCode,
          capacityDescription: this.beneficiary.capacityDescription,
          taxAllocationCode: this.beneficiary.capacityCode,
          taxAllocationDescription: this.beneficiary.capacityDescription,
          plans,
        };
        const insurance = beneficiaryContractedPlan.plans[0].subcontracts[0].insuranceCarrierId;
        sessionStorage.setItem('beneficiaryContractedPlan', JSON.stringify(beneficiaryContractedPlan));
        const query = {
          movementType: this.movementType,
          isRHProtegido: this.isRHProtegido,
          insuranceCarrierId: insurance,
          beneficiaryType: 'HOLDER',
        };

        this.isLoadingValidation = true;
        const insertToValidate = { contractedPlan: beneficiaryContractedPlan };
        const fieldsToValidate = this.fieldsToValidate.getFieldsToValidate('beneficiaryPlanInformation');
        const movementType = this.movementType ? this.movementType.toLowerCase() : null;
        const functionValidate = movementType === 'insert' ? this.movementRecordService.ValidateInsert(insertToValidate, fieldsToValidate) : this.movementRecordService.ValidateImplantation(insertToValidate, fieldsToValidate);

        if (!this.continueWithCriticism) {
          functionValidate.then(() => {
            this.isLoadingValidation = false;
            this.redirectRouter('BeneficiaryAdditionalInformation', query);
          }).catch((error) => {
            this.isLoadingValidation = false;
            if (error.response.status === 422) {
              this.violations = [...error.response.data.violations];

              if (this.hasPermission('sdi_mov_prosseguir_critica')) {
                this.continueWithCriticism = true;
              }

              this.$refs.SnackbarCustomize.open('error', 'Erro de validação de regras no preenchimento do formulário');
            }
          });
        } else {
          sessionStorage.setItem('beneficiaryContractedPlanViolations', JSON.stringify(this.violations));
          this.redirectRouter('BeneficiaryAdditionalInformation', query);
        }
      } else {
        this.$refs.SnackbarCustomize.open('error', 'Preencha todas as informações do titular');
      }
    },
    async onClickSearch() {
      clearTimeout(this.searchTimeout);

      if (!this.beneficiary.financialGroup) return;
      if (!this.beneficiary.cpf) return;

      const cpfRequest = this.beneficiary.cpf ? this.formatter.removeNonDigit(this.beneficiary.cpf) : null;
      const isCpfValid = cpfRequest ? cpfRequest.length === 11 : false;
      const cpfRule = this.rule.cpfValidation(cpfRequest);

      if (!isCpfValid) return;
      if (!cpfRule) return;

      this.searchTimeout = setTimeout(async () => {
        this.loadingSearchButton = true;

        await this.getBeneficiaries();

        this.loadingSearchButton = false;
      }, 1500);
    },
    async getBeneficiaries() {
      const cpfRequest = this.beneficiary.cpf ? this.formatter.removeNonDigit(this.beneficiary.cpf) : null;
      const isCpfValid = cpfRequest ? cpfRequest.length === 11 : false;

      this.$refs.SnackbarCustomize.open(
        'info',
        'Buscando beneficiário no sistema',
        2500,
      );

      if (isCpfValid) {
        await this.getBeneficiaryByPayroll();
      } else if (this.beneficiary.name) {
        await this.getBeneficiaryByPhysicalPerson();
      }
    },
    async getBeneficiaryByPayroll() {
      try {
        const cpfRequest = this.formatter.removeNonDigit(this.beneficiary.cpf);
        const queryString = `?documentNumber=${cpfRequest}`;
        const response = await this.payrollService.FindAllByFilters(queryString);
        if (response.data.content && response.data.content.length > 0) {
          if (response.data.content.length === 1) {
            this.$refs.SnackbarCustomize.open(
              'success',
              'Beneficiário localizado na base cadastral',
              3500,
            );
            this.setBeneficiaryData(response.data.content[0]);
          } else {
            this.beneficiaries = response.data.content;
            this.dialog.show = true;
          }
        } else {
          await this.getBeneficiaryByPhysicalPerson();
        }
      } catch (error) {
        this.getBeneficiaryByPhysicalPerson();
      }
    },
    async getBeneficiaryByPhysicalPerson() {
      try {
        const beneficiaryCpf = this.beneficiary.cpf ? this.beneficiary.cpf.replace(/\D/g, '') : null;
        const payload = {
          isActive: true,
          cpf: beneficiaryCpf,
        };

        const validFilters = Object.entries(payload).filter(([, value]) => value !== null).map(([key, value]) => `${key}=${value}`);
        const queryString = validFilters.length > 0 ? `?${validFilters.join('&')}` : '';
        const response = await this.physicalPersonService.FindAllByFiltersQuery(queryString);

        if (!response.data.empty) {
          this.beneficiaries = await response.data;
          if (this.beneficiaries.length > 0) {
            if (this.beneficiaries.length === 1) {
              this.$refs.SnackbarCustomize.open(
                'success',
                'Beneficiário localizado na base cadastral',
                3500,
              );
              this.setBeneficiaryData(this.beneficiaries[0]);
            } else {
              this.dialog.show = true;
            }
          } else {
            setTimeout(() => {
              this.$refs.SnackbarCustomize.open(
                'success',
                'Prosseguir com o preenchimento dos dados',
                3500,
              );
            }, 2500);
          }
        } else {
          this.showNotFoundAlert();
          setTimeout(() => {
            this.$refs.SnackbarCustomize.open(
              'success',
              'Prosseguir com o preenchimento dos dados',
              3500,
            );
          }, 2500);
        }
      } catch (error) {
        this.handleError();
      }
    },
    setBeneficiaryData(item) {
      this.beneficiary.name = this.formatter.formatToTitleCase(item.name);
      this.beneficiary.cpf = item.cpf ? this.formatter.formatCpf(item.cpf) : item.documentNumber ? this.formatter.formatCpf(item.documentNumber) : null;

      if (!this.beneficiary.admissionDate && item.admissionDate) {
        this.beneficiary.admissionDate = this.formatter.formatDate(item.admissionDate);
      }

      this.$refs.formSearch.resetValidation();
    },
    handleError() {
      this.alert.show = true;
      this.alert.text = this.alert.error.genericError;
      this.closeAlert();
    },
    showNotFoundAlert() {
      this.alert.show = true;
      this.alert.text = this.alert.error.notFound;
      this.clearBeneficiaryData();
      this.closeAlert();
    },
    clearBeneficiaryData() {
      this.beneficiary.cpf = null;
      this.beneficiary.name = null;
      this.beneficiary.admissionDate = null;
    },
    async loadFinancialGroups() {
      this.isLoadingFinancialGroups = true;
      await this.financialGroupService.FindAll().then(async (response) => {
        if (response && response.data) {
          this.financialGroups = response.data;
          if (this.financialGroups && this.financialGroups.length === 1) {
            this.beneficiary.plans[0].financialGroup = this.financialGroups[0].id;
            this.beneficiary.financialGroup = this.financialGroups[0].id;
            await this.loadContractByFinancialGroup(this.beneficiary.plans[0]);
          }
        }
        this.isLoadingFinancialGroups = false;
      }).catch(() => {
        this.isLoadingFinancialGroups = false;
      });
    },
    async loadContractByFinancialGroup(item, type) {
      if (this.loadingForm) return;

      if (type !== 'field') {
        this.financialGroupDefault = item.financialGroup;
        item.contracts = [];
        item.contract = this.isCriticizedCarrier ? item.contract : null;
        item.subcontracts = [];
        item.subcontract = this.isCriticizedCarrier ? item.subcontract : null;
        item.eligibility = this.isCriticizedCarrier ? item.eligibility : null;
        item.eligibilities = [];
        item.units = [];
        item.unit = this.isCriticizedCarrier ? item.unit : null;
        item.unitId = this.isCriticizedCarrier ? item.unitId : null;
        item.unitCode = this.isCriticizedCarrier ? item.unitCode : null;
        item.unitDescription = this.isCriticizedCarrier ? item.unitDescription : null;
        item.plan = this.isCriticizedCarrier ? item.plan : null;
        item.plans = [];
      } else {
        this.financialGroupDefault = this.beneficiary.financialGroup;
      }

      if (this.financialGroupDefault) {
        this.beneficiary.financialGroup = this.financialGroupDefault;
        this.isLoadingContract = true;

        const query = this.mountContractQuery(this.financialGroupDefault);

        await this.contractService.FindAllByFilters(query).then(async (response) => {
          this.setContractPlans(response.data);

          if (response && response.data && response.data.length) {
            let subContractsFalse = response.data.filter((contracts) => contracts.subcontract === false);
            if (this.isReuseMovement && subContractsFalse && subContractsFalse.length > 0) {
              subContractsFalse = await this.getAvailableContracts(this.beneficiary.cpf, subContractsFalse, 'id');
            }
            const contracts = [];
            subContractsFalse.forEach((contract) => {
              let text = '';
              text = (`${(contract.benefit_id && contract.benefit_id.name ? contract.benefit_id.name : contract.benefit_id ? contract.benefit_id : '-')} - ${(contract.carrier_id && contract.carrier_id.xipp_commercial_name ? contract.carrier_id.xipp_commercial_name : '-')} - ${contract.policy ? contract.policy : '-'} - ${contract.contract_owner_id && contract.contract_owner_id.legal_name ? contract.contract_owner_id.legal_name : '-'}`);

              if (contract.carrier_id) {
                contracts.push({
                  accountID: contract.carrier_id.id,
                  contract: contract.id,
                  billing: contract.billing,
                  cutOffDate: contract.cut_off_date ?? null,
                  text,
                });
              }
            });

            this.setContractPlans(contracts);

            if (!this.isCriticizedCarrier) {
              this.cleanSubcontracts();
            }

            this.isLoadingContract = false;

            if (this.isCriticizedCarrier && this.hasSubcontractValidation()) {
              await this.loadSubContracts();
            }
          } else {
            this.cleanContracts();

            this.isLoadingContract = false;
          }
        }).catch(() => {
          this.isLoadingContract = false;
        });
      } else {
        this.processBeneficiaryPlanData();
      }
    },
    processBeneficiaryPlanData() {
      if (this.loadingForm) return;
      this.beneficiary.plans.forEach((item) => {
        item.contracts = [];
        item.contract = this.isCriticizedCarrier ? item.contract : null;
        item.subcontracts = [];
        item.subcontract = this.isCriticizedCarrier ? item.subcontract : null;
        item.eligibilities = [];
        item.eligibility = this.isCriticizedCarrier ? item.eligibility : null;
        item.units = [];
        item.unit = this.isCriticizedCarrier ? item.unit : null;
        item.unitId = this.isCriticizedCarrier ? item.unitId : null;
        item.unitCode = this.isCriticizedCarrier ? item.unitCode : null;
        item.unitDescription = this.isCriticizedCarrier ? item.unitDescription : null;
        item.plans = [];
        item.plan = this.isCriticizedCarrier ? item.plan : null;
        item.validityDate = this.isCriticizedCarrier ? item.validityDate : null;
      });
    },
    mountContractQuery(financialGroupId) {
      let query = `financialGroupIds=${financialGroupId}`;

      if (this.isRHProtegido === true) {
        query += `&allowMovementByProtectedHR=${this.isRHProtegido}`;
      }

      return query;
    },
    setContractPlans(contracts) {
      this.processBeneficiaryPlanData();

      this.beneficiary.plans.forEach((item) => {
        item.contracts = contracts;
      });
    },
    cleanContracts() {
      if (this.loadingForm) return;
      this.beneficiary.plans.forEach((item) => {
        item.contracts = [];
        item.subcontracts = [];
      });
    },
    cleanSubcontracts() {
      this.beneficiary.plans.forEach((item) => {
        item.subcontract = [];
      });
    },
    resetUnitItem(item) {
      item.unit = null;
      item.units = [];
      item.unitId = null;
      item.unitCode = null;
      item.unitDescription = null;
    },
    hasSubcontractValidation() {
      return this.beneficiary.plans.some((item) => Boolean(item.subcontract));
    },
    async loadSubContracts() {
      for (const item of this.beneficiary.plans) {
        await this.loadSubcontractByContractId(item);
      }
    },
    async loadSubcontractByContractId(item, index) {
      if (this.loadingForm) return;
      const contracts = Array.isArray(item.contracts) ? item.contracts : [];

      if (!this.isCriticizedCarrier) {
        item.allowedDates = [null];
        this.$nextTick(() => {
          item.validityDate = '';
        });
      }
      this.setMovementDeadlineValue(item, 'scheduledReleaseDate', null);
      this.setMovementDeadlineValue(item, 'showScheduledReleaseDate', false);
      this.setMovementDeadlineValue(item, 'movementDeadlineConfig', null);
      this.setMovementDeadlineLoading(item, false);
      item.cutOffDate = null; 

      if (item.contract) {
        const contractObject = contracts.find((contract) => contract.contract === item.contract);

        if (contractObject && contractObject.cutOffDate > 0) {
          item.cutOffDate = contractObject.cutOffDate.toString();
        }
      }

      if (item.subcontract) {
        const contractObject = contracts.find((contract) => contract.contract === item.subcontract);
        const movementDeadlineConfig = contractObject
          ? await this.getMovementDeadlineConfigByContractId(
            contractObject.contract,
            this.scheduledReleaseMovementType,
            contractObject.cutOffDate,
          )
          : null;

        if (contractObject
            && contractObject.cutOffDate
            && contractObject.cutOffDate > 0) {  
          item.cutOffDate = contractObject.cutOffDate.toString();  
        }
        this.setMovementDeadlineValue(item, 'movementDeadlineConfig', movementDeadlineConfig);
        this.setMovementDeadlineValue(
          item,
          'showScheduledReleaseDate',
          this.shouldShowMovementDeadlineField(
            item.validityDate,
            movementDeadlineConfig,
          ),
        );
      }

      if (index) {
        this.beneficiaryRowSelected = null;
      }

      if (!this.componentLoaded) {
        this.componentLoaded = true;
      } else {
        item.validityDate = '';
      }

      // eslint-disable-next-line no-param-reassign
      item.subcontracts = [];
      // eslint-disable-next-line no-param-reassign
      item.subcontract = this.isCriticizedCarrier ? item.subcontract : null;
      // eslint-disable-next-line no-param-reassign
      item.eligibility = this.isCriticizedCarrier ? item.eligibility : null;
      // eslint-disable-next-line no-param-reassign
      item.eligibilities = [];
      // eslint-disable-next-line no-param-reassign
      item.plan = this.isCriticizedCarrier ? item.plan : null;
      // eslint-disable-next-line no-param-reassign
      item.plans = [];
      this.resetUnitItem(item);

      if (item.contract !== null) {
        this.isLoadingSubContract = true;
        const movementNotAllowed = '&movementNotAllowed=false';
        const statusesFilter = '&statuses=active&statuses=draft&futureCanceled=true';
        const query = (!this.isCriticizedCarrier ? `${movementNotAllowed}` : '') + statusesFilter;
        await this.contractService.FindByParentIdByFilters(item.contract, query).then(async (response) => {
          if (response && response.data && response.data.length) {
            const subContractsTrue = response.data.filter((contracts) => contracts.subcontract === true);
            const subcontracts = subContractsTrue.map((subcontract) => {
              const subcontractNumber = subcontract.subcontract_number || '-';
              const contractOwnerLegalName = (subcontract.contract_owner_id && subcontract.contract_owner_id.legal_name) || '-';
              const text = `${subcontractNumber} - ${contractOwnerLegalName}`;

              if (subcontract.carrier_id) {
                this.insuranceCarrierId = subcontract.carrier_id.id;
                return {
                  accountID: subcontract.carrier_id.id,
                  subcontract: subcontract.id,
                  billing: subcontract.billing,
                  insuranceCarrierId: subcontract.carrier_id.id,
                  text,
                };
              }
              return null;
            }).filter((subcontract) => subcontract !== null);

            subcontracts.sort((a, b) => a.text.localeCompare(b.text, { numeric: true }));

            // eslint-disable-next-line no-param-reassign
            item.subcontracts = subcontracts;

            if (this.isCriticizedCarrier && item.subcontract) {
              await this.loadEligibilityAndUnitByContractIdAndSubcontractId(item);
            }
          } else {
            // eslint-disable-next-line no-param-reassign
            item.subcontracts = [];
          }
          this.isLoadingSubContract = false;
        }).catch(() => {
          this.isLoadingSubContract = false;
        });
      }

      this.beneficiaryRowSelected = null;

      this.deleteSessionStorages();
    },
    async loadEligibilityAndUnitByContractIdAndSubcontractId(item, index) {
      await Promise.all([
        this.loadEligibilityByContractIdAndSubcontractId(item, index),
        this.loadUnitByContractIdAndSubcontractId(item),
      ])
    },
    async loadEligibilityByContractIdAndSubcontractId(item, index) {
      if (this.loadingForm) return;

      if (index) {
        this.beneficiaryRowSelected = index;
      }
      // eslint-disable-next-line no-param-reassign
      item.eligibility = this.isCriticizedCarrier ? item.eligibility : null;
      // eslint-disable-next-line no-param-reassign
      item.eligibilities = [];
      // eslint-disable-next-line no-param-reassign
      item.plan = this.isCriticizedCarrier ? item.plan : null;
      // eslint-disable-next-line no-param-reassign
      item.plans = [];
      this.resetUnitItem(item);

      if (item.contract !== null && item.subcontract !== null) {
        this.isLoadingEligibility = true;
        const query = `${item.contract}?subcontractId=${item.subcontract}`;
        await this.contractEligibilityService.FindAllByFilters(query).then(async (response) => {
          if (response && response.data && response.data) {
            const contractEligibilitiesMap = response.data.map((e) => ({
              key: e.elegibility_id.id,
              value: e.id,
            }));

            const uniqueRecords = response.data.reduce((acc, obj) => {
              const duplicatedIndex = acc.findIndex((it) => it.elegibility_id.id === obj.elegibility_id.id);
              if (duplicatedIndex === -1) {
                acc.push(obj);
              }
              return acc;
            }, []);

            uniqueRecords.forEach((record) => {
              const contractEligibilities = contractEligibilitiesMap.filter(({ key }) => key === record.elegibility_id.id).map(({ value }) => value);
              this.$set(record.elegibility_id, 'contractEligibilities', contractEligibilities);
            });

            item.eligibilities = uniqueRecords;

            item.eligibilities.forEach((eligibility) => {
              const found = eligibility.elegibility_id.contractEligibilities.includes(item.eligibility);
              if (found) {
                this.$set(eligibility, 'id', item.eligibility);
              }
            });
          }

          this.isLoadingEligibility = false;
          if (this.isCriticizedCarrier && item.eligibility) {
            item.eligibilities.forEach((element) => {
              if (element.id === item.eligibility) {
                item.eligibility = element.id;
              }
            });
            await this.loadPlansByEligibility(item);
          }
        }).catch(() => {
          this.isLoadingEligibility = false;
        });
      }

      this.beneficiaryRowSelected = null;
    },
    async loadUnitByContractIdAndSubcontractId(item) {
      item.units = [];

      if (!item.contract || !item.subcontract) return;

      await this.contractUnitService.GetUnitByContractIdAndSubcontractId(item.contract, item.subcontract)
      .then((response) => {
        if (response && response.data) {
          item.units = response.data;
        }
      })
    },
    async getUnitById(unitId, plan) {
      if (!unitId) return;

      await this.contractUnitService.GetUnitById(unitId)
      .then((response) => {
        const unit = response && response.data
          ? (Array.isArray(response.data) ? response.data[0] : response.data)
          : null;

        if (unit) {
          this.setUnit(plan, unit);
        }
      })
    },
    async loadPlansByEligibility(item, index) {
      if (this.loadingForm) return;

      if (index) {
        this.beneficiaryRowSelected = index;
      }

      item.plan = this.isCriticizedCarrier ? item.plan : null;
      item.plans = [];

      if (item.eligibility !== null) {
        this.isLoadingPlan = true;
        const eligibilityFound = item.eligibilities.find((eligibility) => eligibility.id === item.eligibility);
        let query = '';
        if (eligibilityFound && eligibilityFound.elegibility_id.contractEligibilities) {
          query = `?contractEligibilitiesIds=${eligibilityFound.elegibility_id.contractEligibilities}`;
        } else if (eligibilityFound && eligibilityFound.id) {
          query = `?contractEligibilitiesIds=${eligibilityFound.id}`;
        }

        await this.contractProductService.FindAllByFilters(query).then((response) => {
          const res = response.data;
          const plans = [];
          res.forEach((element) => {
            plans.push({
              eligibility_id: element.eligibility_id,
              ...element.plan_id,
              name: `${element.plan_id.name} - ${element.plan_id.code}`,
            });
            // eslint-disable-next-line no-param-reassign
            item.plans = plans;
          });
          this.isLoadingPlan = false;
        }).catch(() => {
          this.isLoadingPlan = false;
        });
      }

      this.beneficiaryRowSelected = null;
    },
    sortPlans(plans, item) {
      if (plans.length) {
        plans.sort((a, b) => (a.text > b.text ? 1 : -1));
      }
      // eslint-disable-next-line no-param-reassign
      item.plans = plans;
    },
    hasDuplicatedContracts() {
      const contractIds = this.beneficiary.plans.map((plan) => plan.contract);
      return contractIds.some(
        (contract, idx) => contractIds.indexOf(contract) !== idx,
      );
    },
    isEmptyFilters() {
      return !(this.beneficiary.cpf || this.beneficiary.name);
    },
    closeValidateGraceModal() {
      this.validateGraceModal = false;
    },
    adjustOutOfDeadlineDate() {
      this.clearOutOfDeadlineSession();
      this.closeValidateGraceModal();
    },
    confirmGracePeriod() {
      this.hasAcceptedGracePeriod = true;
      this.saveOutOfDeadlineSession();
      this.closeValidateGraceModal();
      this.onClickFinish();
    },
    nonConfirmGracePeriod() {
      this.hasAcceptedGracePeriod = false;
      this.closeValidateGraceModal();
      this.onClickFinish();
    },
    getValidateGracePeriod(params) {
      this.contractService.ValidateGracePeriod(params).then((response) => {
        if (response) {
          let hasGracePeriod = false;
          response.data.forEach((element) => {
            if (element.hasGracePeriod === true) {
              hasGracePeriod = true;
              this.gracePeriods = response.data;
            }
          });
          if (hasGracePeriod) {
            this.validateGraceModal = true;
          } else {
            this.clearOutOfDeadlineSession();
            this.onClickFinish();
          }
        }
      }).catch(() => {
        this.handleError();
      });
    },
    saveOutOfDeadlineSession() {
      const cutOffDate = this.getOutOfDeadlineCutOffDate();
      sessionStorage.setItem('outOfDeadlineMovement', 'true');
      sessionStorage.setItem('outOfDeadlineGracePeriods', JSON.stringify(this.gracePeriods));

      if (cutOffDate) {
        sessionStorage.setItem('outOfDeadlineCutOffDate', cutOffDate);
      } else {
        sessionStorage.removeItem('outOfDeadlineCutOffDate');
      }
    },
    clearOutOfDeadlineSession() {
      sessionStorage.removeItem('outOfDeadlineMovement');
      sessionStorage.removeItem('outOfDeadlineGracePeriods');
      sessionStorage.removeItem('outOfDeadlineCutOffDate');
    },
    normalizeCutOffDate(cutOffDate) {
      if (cutOffDate === null || cutOffDate === undefined) return '';

      return cutOffDate.toString().trim();
    },
    getOutOfDeadlinePlans() {
      const plans = this.beneficiary && Array.isArray(this.beneficiary.plans)
        ? this.beneficiary.plans
        : [];
      const outOfDeadlineContractIds = this.gracePeriods
        .filter((grace) => grace.hasGracePeriod && grace.parentContractId)
        .map((grace) => grace.parentContractId.toString());

      if (outOfDeadlineContractIds.length === 0) return plans;

      const filteredPlans = plans.filter((plan) => outOfDeadlineContractIds.includes((plan.contract || '').toString())
        || outOfDeadlineContractIds.includes((plan.subcontract || '').toString()));

      return filteredPlans.length > 0 ? filteredPlans : plans;
    },
    getPlanCutOffDate(plan) {
      const movementDeadlineConfigCutOffDate = this.normalizeCutOffDate(
        plan && plan.movementDeadlineConfig
          ? plan.movementDeadlineConfig.cut_off_date
          : null,
      );

      if (movementDeadlineConfigCutOffDate) return movementDeadlineConfigCutOffDate;

      const contracts = plan && Array.isArray(plan.contracts) ? plan.contracts : [];
      const contract = contracts.find((item) => String(item.contract) === String(plan.contract)
        || String(item.contract) === String(plan.subcontract));

      return this.normalizeCutOffDate(contract ? contract.cutOffDate || contract.cut_off_date : null);
    },
    getOutOfDeadlineCutOffDate() {
      const cutOffDates = [];
      this.getOutOfDeadlinePlans().forEach((plan) => {
        const cutOffDate = this.getPlanCutOffDate(plan);

        if (cutOffDate && !cutOffDates.includes(cutOffDate)) {
          cutOffDates.push(cutOffDate);
        }
      });

      return cutOffDates.join(', ');
    },
    getGracePeriodMessage(grace) {
      return `${grace.benefitId} - ${grace.policy} - Acima do prazo máximo de ${grace.daysGracePeriod} dias.`;
    },
    isAcceptedGracePeriod(contract) {
      let result = null;
      const hasAccepted = this.hasAcceptedGracePeriod;
      this.gracePeriods.some((grace) => {
        if (grace.parentContractId === contract && grace.benefitId !== null) {
          result = hasAccepted;
        }
      });

      return result;
    },
    async validateShowScheduledReleaseDate(item) {
      if (!item) return;

      const contracts = Array.isArray(item.contracts) ? item.contracts : [];
      const contractObject = contracts.find((contract) => contract.contract === item.contract);
      const subcontracts = Array.isArray(item.subcontracts) ? item.subcontracts : [];
      const subcontractObject = subcontracts.find((contract) => contract.subcontract === item.subcontract);

      const movementDeadlineConfig = contractObject
        ? await this.getMovementDeadlineConfigByContractId(
          subcontractObject.subcontract,
          this.scheduledReleaseMovementType,
          contractObject.cutOffDate,
        )
        : null;
      this.setMovementDeadlineValue(item, 'movementDeadlineConfig', movementDeadlineConfig);
      this.setMovementDeadlineValue(
        item,
        'showScheduledReleaseDate',
        this.shouldShowMovementDeadlineField(item.validityDate, movementDeadlineConfig),
      );
      this.setMovementDeadlineValue(item, 'scheduledReleaseDate', null);
      this.changeLoadingSheduledReleaseDate(item, item.showScheduledReleaseDate);
      await this.syncMovementDeadlineView();

      if (item.showScheduledReleaseDate && item.validityDate) {
        try {
          const result = await this.getCalculateScheduledDate(
            item.validityDate,
            item.subcontract,
            this.scheduledReleaseMovementType,
          );
          this.setMovementDeadlineValue(item, 'scheduledReleaseDate', result || '-');
          await this.syncMovementDeadlineView();
        } catch (error) {
          this.$refs.SnackbarCustomize.open('error', 'Ocorreu um erro na busca pela data agendada');
        } finally {
          this.changeLoadingSheduledReleaseDate(item, false);
          await this.syncMovementDeadlineView();
        }
      }
    },
    async clearScheduledReleaseDate(item) {
      if (!item) return;

      const contracts = Array.isArray(item.contracts) ? item.contracts : [];
      const contractObject = contracts.find((contract) => contract.contract === item.contract);
      const subcontracts = Array.isArray(item.subcontracts) ? item.subcontracts : [];
      const subcontractObject = subcontracts.find((contract) => contract.subcontract === item.subcontract);
      const movementDeadlineConfig = contractObject
        ? await this.getMovementDeadlineConfigByContractId(
          subcontractObject.subcontract,
          this.scheduledReleaseMovementType,
          contractObject.cutOffDate,
        )
        : null;
      this.setMovementDeadlineValue(item, 'movementDeadlineConfig', movementDeadlineConfig);
      this.setMovementDeadlineValue(
        item,
        'showScheduledReleaseDate',
        this.shouldShowMovementDeadlineField(item.validityDate, movementDeadlineConfig),
      );
      this.setMovementDeadlineValue(item, 'scheduledReleaseDate', null);
      this.changeLoadingSheduledReleaseDate(item, false);
      await this.syncMovementDeadlineView();
    },
    changeLoadingSheduledReleaseDate(item, value = null) {
      if (!item) return;

      this.setMovementDeadlineLoading(
        item,
        typeof value === 'boolean' ? value : !item.loadingScheduledReleaseDate,
      );
    },
  },

  async created() {
    this.componentLoaded = false;
    this.formatter = new Formatters();
    this.rule = new Rules();
    this.documentService = new DocumentService();
    this.movementRecordService = new MovementRecordService();
    this.fieldsToValidate = new MovementRecordFormFieldsToValidate();
    this.physicalPersonService = new PhysicalPersonService();
    this.financialGroupService = new FinancialGroupService();
    this.contractService = new ContractService();
    this.contractUnitService = new ContractUnitService();
    this.contractEligibilityService = new ContractEligibilityService();
    this.contractProductService = new ContractProductService();
    this.payrollService = new PayrollService();
    this.carrierService = new CarrierService();
    this.insuredService = new InsuredService();
    this.movementType = this.$route.query.movementType;
    this.loading = true;
  },
};
</script>
